// extracted by mini-css-extract-plugin
export default {"sectionHeader":"OmniboxResultRowAdapter_sectionHeader__q-s-S","isTopSection":"OmniboxResultRowAdapter_isTopSection__GUwx8"};